<template>
  <div v-if="testimonials.length" data-name="testimonial-wrapper" :class="[$style.wrapper]">
    <div data-name="gradient-underlay" :class="$style.underlay"></div>

    <close @click.native="close" v-touch.native="close" aria-label="Close Testimonials Lightbox" title="Close Testimonials Lightbox" :class="$style.close"></close>

    <div data-name="testimonial-container" :class="$style.container">
      <div :class="$style.inner">
        <logo :class="$style.logo" :ns="'testimonial'"></logo>
          <header :class="$style.header">
            <h1 :class="$style.title">Customer Testimonials</h1>
          </header>

          <div data-name="testimonials" :class="$style.testimonials">
            <template v-for="(item, index) in testimonials">
              <testimonial-item :person="item"></testimonial-item>
            </template>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import Close from './Close.vue';
import Logo from './Logo.vue';
import TestimonialItem from './TestimonialItem.vue';
import axios from 'axios';
export default {
  data() {
    return {
      testimonials: []
    };
  },

  components: {
    Close,
    Logo,
    TestimonialItem
  },
  beforeCreate() {
    axios.get('/static/info.json').then(response => {
      this.testimonials = response.data.testimonials;
    });
  },
  methods: {
    close(e) {
      this.$store.dispatch('goToLastAppState');
    }
  }
};
</script>

<style lang="scss" module>
@import '../assets/css/globals.scss';
.wrapper {
  z-index: 9999;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: white;
}

.underlay {
  top: 0;
  left: 0;
  position: absolute;
  z-index: 0;
  width: 100vw;
  height: 100vh;

  opacity: 0.1;

  background: linear-gradient(
    180deg,
    rgba($sapGreen, 1) 0%,
    rgba(255, 255, 255, 1) 100%
  );
}

.close {
  top: 10px;
  right: 10px;
  z-index: 2;
  width: 40px;
  height: 40px;
  position: absolute;

  @include medium {
    top: 32px;
    right: 32px;
  }
}

.container {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100vh;
  overflow: auto;
}

.inner {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.logo {
  width: 300px;
  padding-top: 20px;
  margin-bottom: 50px;
  margin-left: auto;
  margin-right: auto;

  @include medium {
    padding-top: 0;
  }
}

.header {
  text-align: center;
  margin-bottom: 40px;
  @include large {
    margin-bottom: 80px;
  }
}

.title {
  margin-top: 0;
  margin-bottom: 0;

  color: $sun;
  font-size: 40px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/Testimonials.vue